
<template>
    <div class="card-body p-0">
        <slot/>
    </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";

export default defineComponent({
    name: "GridBody"
});

</script>
